<template>
  <div
    :class="bem()"
  >
    <div :class="bem('inner')">
      <VisionHeading
        v-if="!selected && !forceDowngrade"
        tag="h3"
        size="h6"
        :class="bem('title')"
      >
        Want to See Better?
      </VisionHeading>
          
      <p :class="bem('description')">
        <!-- eslint-disable vue/no-v-html -->
        <span
          v-if="selected || forceDowngrade"
          :class="bem('description-success', {'is-active': selected})"
          v-html="upgradedText"
        />
        <span
          v-else
          v-html="defaultText"
        />
        <!-- eslint-enable vue/no-v-html -->
      </p>
    </div>
    <VisionLink
      :line-link="true"
      :theme="selected || forceDowngrade ? 'grey' : 'gradient'"
      :is-button="true"
      :class="bem('cta', {selected})"
      @click="handleUpsellClick"
    >
      <template v-if="selected || forceDowngrade">
        Downgrade
      </template>
      <template v-else>
        Upgrade for {{ $tca(props.lensTechUpsell.priceDifference) }}
      </template>
    </VisionLink>
  </div>
</template>

<script setup lang="ts">
import CustomisedProduct from '~/models/CustomisedProduct'
const bem = useBEM('CartItemLensTechUpsell')

const forceDowngrade = ref(false)

const props = defineProps({
  lensTechUpsell: {
      type: Object,
      required: true,
  },
  lensTechDowngrade: {
    type: Object,
    required: false,
    default: () => ({}),
  },
  customisedProduct: {
    type: CustomisedProduct,
    default: () => ({}),
  },
  selected: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['updateLensChoice'])

const defaultText = computed(() => {
  return `Upgrade to Premium ${props.lensTechUpsell.optionTech.displayTitle.replace('Standard', '')} Lenses`
})

const upgradedText = computed(() => {
  return `Successfully upgraded to ${props.customisedProduct.lensChoice.optionTech.displayTitle}`
})

function handleUpsellClick() {
  emit('updateLensChoice', {
    customisedProduct: props.customisedProduct,
    selectedOption: props.selected ? props.lensTechDowngrade : props.lensTechUpsell,
    downgrade: props.selected
  })
  forceDowngrade.value = true
}
</script>

<style lang="postcss">
.CartItemLensTechUpsell {
  @apply flex justify-between items-center gap-3
  mt-4;
}

.CartItemLensTechUpsell__description {
  @apply text-xxs font-light text-grey-500;
}

.CartItemLensTechUpsell__description-success {
  @apply text-transparent;

  &--is-active {
    @apply text-green;
  }
}

.CartItemLensTechUpsell__cta {
  @apply text-xs whitespace-nowrap;
}
</style>
